export const getPosts = state => state.post.postList;
export const getPostDetails = state => state.post.postDetails;
